import { render, staticRenderFns } from "./QuestionMatrixRate.vue?vue&type=template&id=614371e1&scoped=true&"
import script from "./QuestionMatrixRate.vue?vue&type=script&lang=js&"
export * from "./QuestionMatrixRate.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMatrixRate.vue?vue&type=style&index=0&id=614371e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614371e1",
  null
  
)

export default component.exports